var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-tertiary absolute rounded-full p-2",attrs:{"type":"button"}},[_c('CloseIcon',{staticClass:"h-4 w-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }